import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", subject: "General inquiry", message: "" });
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/contact", form);
            toast.success("Message received. Talk soon.");
            setForm({ name: "", email: "", subject: "General inquiry", message: "" });
        } catch { toast.error("Something went wrong."); }
        finally { setBusy(false); }
    };
    return (
        <main data-testid="contact-page" className="pt-32 pb-32 min-h-screen">
            <section className="mx-auto max-w-[1600px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
                <div className="lg:col-span-6">
                    <p className="eyebrow">Contact</p>
                    <h1 className="font-display text-6xl md:text-9xl mt-4 leading-[0.9]">Get<br /><em className="text-[color:var(--gold)]">in touch</em>.</h1>
                    <p className="mt-8 max-w-md text-[color:var(--cream-muted)]">General inquiries, press, community questions — we read every message.</p>
                    <div className="mt-14 space-y-6 text-sm">
                        <div>
                            <p className="eyebrow">Direct line</p>
                            <a href="tel:+13802000884" className="mt-2 block font-serif text-2xl text-[color:var(--soft-cream)] hover:text-[color:var(--gold)] transition-colors duration-300" data-testid="contact-phone">
                                (380) 200-0884
                            </a>
                            <p className="mt-1 text-xs uppercase tracking-[0.24em] text-[color:var(--cream-muted)]">Text or leave a voicemail — we return every message.</p>
                        </div>
                        <div>
                            <p className="eyebrow">Community</p>
                            <p className="mt-2">hello@mrsblackinlove.com</p>
                        </div>
                        <div>
                            <p className="eyebrow">Press</p>
                            <p className="mt-2">press@mrsblackinlove.com</p>
                        </div>
                        <div>
                            <p className="eyebrow">Partnerships</p>
                            <p className="mt-2">partnerships@mrsblackinlove.com</p>
                        </div>
                    </div>
                </div>
                <form onSubmit={submit} className="lg:col-span-6 space-y-6 border border-[color:var(--espresso)] p-10">
                    <input required className="input-line" placeholder="Name" value={form.name} onChange={set("name")} data-testid="contact-name" />
                    <input required type="email" className="input-line" placeholder="Email" value={form.email} onChange={set("email")} data-testid="contact-email" />
                    <input required className="input-line" placeholder="Subject" value={form.subject} onChange={set("subject")} data-testid="contact-subject" />
                    <textarea required className="input-line" placeholder="Your message" value={form.message} onChange={set("message")} data-testid="contact-message" />
                    <button type="submit" disabled={busy} className="btn-gold btn-gold-solid" data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</button>
                </form>
            </section>
        </main>
    );
}
